export function sanitizeAmount(amount: number | null | undefined) {
  if (typeof amount === 'number' && Number.isFinite(amount)) {
    return Math.round(amount * 100) / 100;
  }

  return 0;
}
